// extracted by mini-css-extract-plugin
export default {"notificationsTab":"NotificationsTab_notificationsTab__eZYRT","notificationsContent":"NotificationsTab_notificationsContent__AWDdt"};